function ChangeSearchParamRdc() {
    const ChangeSearchParamRdc = (state, payload) => {
        const newState = state;
        if (newState.searchParams == undefined) {
            newState.searchParams = new Map();
        }
        newState.searchParams.set(payload.key, payload.value);
        newState.isLoading = true;
        return newState;
    };
    return ChangeSearchParamRdc;
}
export default ChangeSearchParamRdc;
//# sourceMappingURL=ChangeSearchParamRdc.js.map